import { GroupingRule } from "./grouping.js";
/**
 * @public
 */
export class ConditionRule extends GroupingRule {
    _condition;
    constructor(type, condition, rules) {
        super(type, rules);
        this._condition = condition;
    }
    get condition() {
        return this._condition;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            condition: this._condition,
        };
    }
}
/**
 * @public
 */
(function (ConditionRule) {
    function isConditionRule(value) {
        return value instanceof ConditionRule;
    }
    ConditionRule.isConditionRule = isConditionRule;
})(ConditionRule || (ConditionRule = {}));
//# sourceMappingURL=condition.js.map